var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.sum > 0
      ? _c("p", [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.t("health", "Great, you saved {sum} yet.", {
                  sum: "" + _vm.sum + _vm.currency
                })
              ) +
              "\n\t"
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }